import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { luister, aantalLopend } from '../utils/laadStatus';

// Pas na een korte drempel tonen: snelle verzoeken (en de minuutronde op de achtergrond)
// mogen niet laten flikkeren. Duurt het langer, dan ook een woord — een dunne balk alleen
// viel juist níet op (Joris, 4 nov).
const TOON_NA_MS = 400;
const TEKST_NA_MS = 1500;
const VERBERG_NA_MS = 150;

export default function Laadbalk() {
  const [stand, setStand] = useState('uit'); // 'uit' | 'balk' | 'tekst'
  useEffect(() => {
    let toon = null;
    let tekst = null;
    let verberg = null;
    const wis = () => { clearTimeout(toon); clearTimeout(tekst); clearTimeout(verberg); };
    const opWijziging = (n) => {
      if (n > 0) {
        clearTimeout(verberg);
        if (!toon) {
          toon = setTimeout(() => setStand((s) => (s === 'uit' ? 'balk' : s)), TOON_NA_MS);
          tekst = setTimeout(() => setStand('tekst'), TEKST_NA_MS);
        }
      } else {
        clearTimeout(toon); clearTimeout(tekst);
        toon = null; tekst = null;
        verberg = setTimeout(() => setStand('uit'), VERBERG_NA_MS);
      }
    };
    const af = luister(opWijziging);
    opWijziging(aantalLopend());
    return () => { af(); wis(); };
  }, []);

  if (stand === 'uit') return null;
  return (
    <Box role="status" aria-live="polite" data-testid="laadbalk"
      sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (t) => t.zIndex.modal + 10, pointerEvents: 'none' }}>
      <LinearProgress sx={{ height: 3 }} aria-label="Gegevens laden" />
      {stand === 'tekst' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.75 }}>
          <Typography sx={{
            fontSize: 12, fontWeight: 600, px: 1.25, py: 0.25, borderRadius: '9999px',
            bgcolor: 'primary.main', color: 'primary.contrastText', boxShadow: 1,
          }}>
            Laden…
          </Typography>
        </Box>
      )}
    </Box>
  );
}
